import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import { IRiderOrderDto } from '../models/shipday.model';
import {
  IApiResponse,
  IFilterPaginationDto,
  IAdminOrderDto,
  IOtpDto,
  IRefundDto,
  IOrderDto,
  IManualOrderDto,
} from '../models';

@Injectable()
export class OrderService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOrderList(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IAdminOrderDto[]> {
    return this.post(`admin/order/list/${id}`, model);
  }

  public getOrder(id: number): Observable<IOrderDto> {
    return this.get(`admin/order/${id}`);
  }

  public trackOrder(id: number): Observable<IApiResponse<string>> {
    return this.get(`admin/order/track/${id}`);
  }

  public acceptOrder(model: IRiderOrderDto): Observable<IApiResponse<boolean>> {
    return this.put(`admin/order/accept`, model);
  }

  public rejectOrder(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/order/reject/${id}`, null);
  }

  public sendOrderReceipt(
    id: number,
    model: KeyValue<number, string>,
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/order/receipt/${id}`, model);
  }

  public deleteOrder(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/order/${id}`);
  }

  public sendOtp(model: IOtpDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/order/otp`, model);
  }

  public refundAmount(model: IRefundDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/order/refund`, model);
  }

  public placeTestOrder(id: number): Observable<IApiResponse<boolean>> {
    return this.post(`admin/order/test/${id}`, null);
  }

  public saveOrderManually(
    model: IManualOrderDto,
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/order/manual/`, model);
  }
}
